import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import * as userService from '../services/userService';

import Swal from "sweetalert2";
import { Password } from 'primereact/password';
import { AuthContext } from '../../contexts/AuthContext';
import { passRegex } from '../../utils/Validations';
import { InputText } from 'primereact/inputtext';

export function DirectorFirstLogin() {

    const navigate = useNavigate();
    const { firstLoginPass, user } = useContext(AuthContext)

    const [formData, setFormData] = useState({
        oldPass: firstLoginPass,
        password: '',
        repeatPassword: '',
        phoneNumber: '',
        email: '',
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (!passRegex.test(formData.password)) {
            Swal.fire({
                title: "Паролата трябва да съдържа поне 8 символа, включващи главни и малки букви, цифри и специален символ!",
                icon: "warning",
            });
            return;
        } else if (formData.password != formData.repeatPassword) {
            Swal.fire({
                title: "Паролите не са еднакви!",
                icon: "warning",
            });
            return;
        }
        
        const body = {
            id: user.id,
            oldPass: formData.oldPass,
            newPass: formData.password,
            repeatPassword: formData.repeatPassword,
            phoneNumber: formData.phoneNumber,
            email: formData.email,
            firstLogin: true
        }


        console.log('test 123');
        console.log(body);

        userService.chpass(body)
            .then(data => {
                navigate('/schadm/');
            })
            .catch((error) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: error.message,
                    icon: "warning",
                    button: "Добре",
                });
            });
    }

    return (
        <main>
            <div class="container h-100">

                <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                                <div class="card mb-3">

                                    <div class="card-body">

                                        <div class="pt-4 pb-2">
                                            <h5 class="card-title text-center pb-0 fs-4 use-font">Първоначално влизане в системата</h5>
                                            <p class="text-center small use-font">Въведете нова парола и данни за контакт</p>
                                        </div>

                                        <form class="row g-3 needs-validation" novalidate>

                                            <div className="d-flex flex-wrap gap-3">

                                                <span className="p-float-label labels">
                                                    <Password
                                                        inputId="pass"
                                                        name='password'
                                                        value={formData.password}
                                                        onChange={handleChange}
                                                        feedback={false}
                                                        toggleMask
                                                        className={`${formData.password.length > 5 || formData.password === '' ? '' : 'p-invalid'} w-100`}
                                                    />
                                                    <label htmlFor="username"> Парола*</label>
                                                </span>

                                                <span className="p-float-label labels">
                                                    <Password
                                                        inputId="passold"
                                                        name='repeatPassword'
                                                        value={formData.repeatPassword}
                                                        onChange={handleChange}
                                                        feedback={false}
                                                        toggleMask
                                                        className={`${formData.password.length > 5 || formData.password === '' ? '' : 'p-invalid'} w-100`}
                                                    />
                                                    <label htmlFor="pass">Повтори парола*</label>
                                                </span>

                                                <span className="p-float-label labels">
                                                    <InputText
                                                        id="phoneNumber"
                                                        name='phoneNumber'
                                                        value={formData.phoneNumber}
                                                        onChange={handleChange}
                                                        feedback={false}
                                                        toggleMask
                                                        className={`${formData.phoneNumber.length < 10 || formData.password === '' ? '' : 'p-invalid'} w-100`}
                                                    />
                                                    <label htmlFor="phoneNumber"> Телефонен номер*</label>
                                                </span>

                                                <span className="p-float-label labels">
                                                    <InputText
                                                        id="email"
                                                        name='email'
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        feedback={false}
                                                        toggleMask
                                                        className={`${formData.email === '' ? '' : 'p-invalid'} w-100`}
                                                    />
                                                    <label htmlFor="username"> Еmail адрес *</label>
                                                </span>

                                            </div>

                                            <div class="col-12 mt-5">
                                                <button class="btn btn-primary w-100" type="submit" onClick={onSubmit}>Продължи</button>
                                            </div>

                                        </form>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </section>

            </div>
        </main>
    );
}

export default DirectorFirstLogin;